var exports = {
  "kL": "x127c5a35--85d062--container",
  "Qs": "x127c5a35--85d062--content",
  "mJ": "x127c5a35--85d062--reaction",
  "Im": "x127c5a35--85d062--comment",
};

module.exports = exports;
